module.exports = __webpack_public_path__ + "static/nationalpark-heavy-1d2b472011b81bf8a0b9b0adce10ce6d.woff";